import { useEffect, useRef } from 'react'

// The till's lists refresh themselves every 20 s, the same cadence as HOP. The callback
// owns the "is a load already running" check; this hook only owns the timer, and stops it
// when the screen unmounts.
export const SILENT_REFRESH_MS = 20_000

export function useSilentRefresh(refresh: () => void, everyMs: number = SILENT_REFRESH_MS): void {
  const latest = useRef(refresh)
  latest.current = refresh

  useEffect(() => {
    const timer = setInterval(() => latest.current(), everyMs)
    return () => clearInterval(timer)
  }, [everyMs])
}
